<script lang="ts" setup>
import PrivacyPage from '@consumer/modules/legal/PrivacyPage.vue'
</script>

<template>
  <PrivacyPage/>
</template>
